import { useDispatch, useSelector } from "react-redux";
import { BusinessInstance } from "../utils/businessClass";
import { Dashboard } from "./DashboardPage";

export const BusinessDetailsPage = () => {
  const dispatch = useDispatch();
  const businesses = useSelector((state: any) => state.business);

  const handleSelectBusiness = async (business: any) => {
    console.log(business);
    await BusinessInstance.setBusiness(business);
  };

  return (
    <Dashboard header="Business Details">
      <div>
        <h2>BUSINESS DETAIL PAGE</h2>
      </div>
    </Dashboard>
  );
};
